@if (!templateForPermitForm) {
<div class="permit-form-non-janus-table-container">
  <table class="table table-bordered" *ngIf="layoutModel && layoutModel.isVisible !== false">
    <ng-container *ngFor="let row of layoutModel.rows; let rowIndex = index">
      <ng-container *ngIf="row.isVisible !== false">
      <tr [style.background-color]="row.backgroundColor">
        <ng-container *ngFor="let cell of getCellsForRow(rowIndex)">
        <!-- Dynamic columns for List Data Entity -->
        <ng-container *ngIf="shouldRenderAsDynamicColumns(cell); else normalCell">
          <td *ngFor="let listItem of getListItems(cell.entity)"
              [style.background-color]="cell.backgroundColor || null"
              [class.border-danger]="!isReadOnly && cell.entity.isRequired && !cell.entity.isValid"
              class="text-center">

            <!-- Input Mode: Show controls -->
            <div *ngIf="!isReadOnly" class="form-check" [class.form-check-inline]="true">
              <input
                [type]="getListControlType(cell.entity)"
                class="form-check-input"
                [class.is-invalid]="cell.entity.isRequired && !cell.entity.isValid"
                [name]="getListInputName(cell.entity)"
                [id]="getListItemId(cell.entity, listItem)"
                [value]="listItem.id || listItem.value"
                [checked]="isListItemSelected(cell.entity, listItem)"
                (change)="onListItemChange(cell.entity, listItem, $event)"
              />
              <label class="form-check-label"
                     [for]="getListItemId(cell.entity, listItem)"
                     [ngClass]="{ 'font-weight-bold': cell.entity.isRequired }">
                {{ listItem.text }}<span *ngIf="cell.entity.isRequired" class="text-danger">*</span>
              </label>
            </div>

            <!-- View Mode: Show checkbox or radio icon -->
            <div *ngIf="isReadOnly">
              <!-- Checkbox icons -->
              <ng-container *ngIf="getListControlType(cell.entity) === 'checkbox'">
                <i *ngIf="isListItemSelected(cell.entity, listItem)"
                   class="material-icons"
                   style="color: #0d6efd; vertical-align: middle;">check_box</i>
                <i *ngIf="!isListItemSelected(cell.entity, listItem)"
                   class="material-icons text-muted"
                   style="vertical-align: middle;">check_box_outline_blank</i>
              </ng-container>

              <!-- Radio button icons -->
              <ng-container *ngIf="getListControlType(cell.entity) === 'radio'">
                <i *ngIf="isListItemSelected(cell.entity, listItem)"
                   class="material-icons"
                   style="color: #0d6efd; vertical-align: middle;">radio_button_checked</i>
                <i *ngIf="!isListItemSelected(cell.entity, listItem)"
                   class="material-icons text-muted"
                   style="vertical-align: middle;">radio_button_unchecked</i>
              </ng-container>
            </div>
          </td>
        </ng-container>

        <!-- Normal cell rendering -->
        <ng-template #normalCell>
          <td [attr.colspan]="cell.colspan || 1"
              [attr.rowspan]="getAdjustedRowSpan(rowIndex, cell)"
              [style.background-color]="cell.backgroundColor || null">
            <!-- Static Text -->
            <span *ngIf="cell.staticText">{{ cell.staticText }}</span>

            <!-- Entity Input/View (non-dynamic list rendering) -->
            <!-- Note: Don't render if this would have been dynamic columns (should never happen due to else clause, but defense in depth) -->
            <wm-data-entity-input
              *ngIf="!isReadOnly && cell.entity && !shouldRenderAsDynamicColumns(cell)"
              orientation="horizontal"
              [entity]="cell.entity"
              [form]="form"
              [applicationId]="applicationId"
              [activity]="activity"
              #dataEntityInput
              [showLabel]="false"
            ></wm-data-entity-input>
            <wm-data-entity-view
              *ngIf="isReadOnly && cell.entity && !shouldRenderAsDynamicColumns(cell)"
              orientation="horizontal"
              [entity]="cell.entity"
              [form]="form"
              [applicationId]="applicationId"
              [activity]="activity"
              [showLabel]="false"
            ></wm-data-entity-view>

            <!-- Layout Model Rendering -->
            <ng-container *ngIf="cell.layoutModel">
              <!-- Table Layout -->
              <wm-data-entity-table-layout-input
                *ngIf="cell.layoutModel.type === 'table-data-entity-layout'"
                [layoutModel]="cell.layoutModel"
                [form]="form"
                [isReadOnly]="isReadOnly"
                [applicationId]="applicationId"
                [activity]="activity"
              ></wm-data-entity-table-layout-input>

              <!-- Group Layout -->
              <wm-data-entity-group-layout-input
                *ngIf="cell.layoutModel.type === 'group-data-entity-layout'"
                [layoutModel]="cell.layoutModel"
                [form]="form"
                [isReadOnly]="isReadOnly"
                [applicationId]="applicationId"
                [activity]="activity"
              ></wm-data-entity-group-layout-input>

              <!-- Row Layout -->
              <wm-data-entity-row-layout-input
                *ngIf="cell.layoutModel.type === 'row-data-entity-layout'"
                [layoutModel]="cell.layoutModel"
                [form]="form"
                [isReadOnly]="isReadOnly"
                [applicationId]="applicationId"
                [activity]="activity"
              ></wm-data-entity-row-layout-input>

              <!-- Default Entity Layout -->
              <ng-container *ngIf="cell.layoutModel.type === 'default-data-entity-layout'">
                <wm-data-entity-input
                  *ngIf="!isReadOnly && cell.layoutModel.entity"
                  orientation="horizontal"
                  [entity]="cell.layoutModel.entity"
                  [form]="form"
                  [applicationId]="applicationId"
                  [activity]="activity"
                ></wm-data-entity-input>
                <wm-data-entity-view
                  *ngIf="isReadOnly && cell.layoutModel.entity"
                  orientation="horizontal"
                  [entity]="cell.layoutModel.entity"
                  [form]="form"
                  [applicationId]="applicationId"
                  [activity]="activity"
                ></wm-data-entity-view>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </ng-container>
    </tr>
    <!-- Validation message row for dynamic columns -->
    <tr *ngIf="!isReadOnly && hasInvalidDynamicColumns(row)" class="validation-row">
      <td [attr.colspan]="getTotalColumnCount(row)" class="bg-danger text-white small text-center py-1">
        <i class="material-icons" style="font-size: 16px; vertical-align: middle;">error</i>
        Required field. Please make a selection.
      </td>
    </tr>
      </ng-container>
    </ng-container>
  </table>
</div>
}
@else {

  <div class="permit-form-table-container mat-elevation-z1 janus-table" *ngIf="layoutModel && layoutModel.isVisible !== false">
  <table class="permit-form-data-entity-table mat-table">
    <ng-container *ngFor="let row of layoutModel.rows; let rowIndex = index">
      <ng-container *ngIf="row.isVisible !== false">
      <tr class="mat-row" [style.background-color]="row.backgroundColor">
        <ng-container *ngFor="let cell of getCellsForRow(rowIndex); let cellIndex = index">
        <!-- Dynamic columns for List Data Entity (NEW) -->
        <ng-container *ngIf="shouldRenderAsDynamicColumns(cell); else normalCellNew">
          <td *ngFor="let listItem of getListItems(cell.entity)"
              [style.background-color]="cell.backgroundColor || null"
              [class.border-danger]="!isReadOnly && cell.entity.isRequired && !cell.entity.isValid"
              [class.required-input-border]="!isReadOnly && isDynamicListRequiredAndEmpty(cell.entity)"
              class="text-center permit-form-dynamic-cell mat-cell">

            <!-- Input Mode: wm-common-checkbox for checkbox, native radio for proper radio grouping -->
            <div *ngIf="!isReadOnly" class="form-check form-check-inline permit-form-control">

              <!-- Checkbox: use wm-common-checkbox to match design system styling -->
              <ng-container *ngIf="getListControlType(cell.entity) === 'checkbox'">
                <wm-common-checkbox
                  class="permit-form-checkbox"
                  [class.is-invalid]="cell.entity.isRequired && !cell.entity.isValid"
                  [data]="{
                    checked: isListItemSelected(cell.entity, listItem),
                    label: listItem.text,
                    name: getListItemId(cell.entity, listItem),
                    required: cell.entity.isRequired,
                    showRequiredStar: false,
                    fontWeight: cell.entity.isRequired ? '700' : '400',
                    hasError: cell.entity.isRequired && !cell.entity.isValid
                  }"
                  (change)="onListItemCommonCheckboxChange(cell.entity, listItem, $event)">
                </wm-common-checkbox>
              </ng-container>

              <ng-container *ngIf="getListControlType(cell.entity) === 'radio'">
                <wm-common-radio
                  class="permit-form-radio"
                  [class.is-invalid]="cell.entity.isRequired && !cell.entity.isValid"
                  [data]="{
                    options: [{ label: listItem.text, value: listItem.id || listItem.value, disabled: false }],
                    value: isListItemSelected(cell.entity, listItem) ? (listItem.id || listItem.value) : null,
                    name: getListInputName(cell.entity),
                    required: cell.entity.isRequired,
                    direction: 'column'
                  }"
                  (valueChange)="onListItemCommonRadioChange(cell.entity, listItem, $event)">
                </wm-common-radio>
              </ng-container>
            </div>

            <!-- View Mode: use wm-common-icon for state icons -->
            <div *ngIf="isReadOnly">
              <!-- Checkbox state icons -->
              <ng-container *ngIf="getListControlType(cell.entity) === 'checkbox'">
                <wm-common-icon
                  *ngIf="isListItemSelected(cell.entity, listItem)"
                  class="permit-form-state-icon permit-form-state-icon--selected"
                  [data]="{ iconName: 'check_box' }"></wm-common-icon>
                <wm-common-icon
                  *ngIf="!isListItemSelected(cell.entity, listItem)"
                  class="permit-form-state-icon text-muted"
                  [data]="{ iconName: 'check_box_outline_blank' }"></wm-common-icon>
              </ng-container>

              <!-- Radio button state icons -->
              <ng-container *ngIf="getListControlType(cell.entity) === 'radio'">
                <wm-common-icon
                  *ngIf="isListItemSelected(cell.entity, listItem)"
                  class="permit-form-state-icon permit-form-state-icon--selected"
                  [data]="{ iconName: 'radio_button_checked' }"></wm-common-icon>
                <wm-common-icon
                  *ngIf="!isListItemSelected(cell.entity, listItem)"
                  class="permit-form-state-icon text-muted"
                  [data]="{ iconName: 'radio_button_unchecked' }"></wm-common-icon>
              </ng-container>
            </div>
          </td>
        </ng-container>

        <!-- Normal cell rendering (NEW) -->
        <ng-template #normalCellNew>
          <td [attr.colspan]="cell.colspan || 1"
              [attr.rowspan]="getAdjustedRowSpan(rowIndex, cell)"
              [style.background-color]="cell.backgroundColor || null"
              [class.required-input-border]="!isReadOnly && isFieldRequiredAndEmpty(cell)"
              class="permit-form-data-entity-cell mat-cell">

            <!-- Static Text via wm-common-text -->
            <!-- Added by Amisha on 03-07-2026.
                 Reason: Janus table-layout labels are static-text cells, so pass required state into the shared common-text component. -->
            <wm-common-text
              *ngIf="cell.staticText"
              [data]="{
                text: cell.staticText,
                required: false
              }"></wm-common-text>

            <!-- Entity Input/View (non-dynamic list rendering) -->
            <wm-data-entity-input
              *ngIf="!isReadOnly && cell.entity && !shouldRenderAsDynamicColumns(cell)"
              orientation="horizontal"
              [entity]="cell.entity"
              [form]="form"
              [applicationId]="applicationId"
              [activity]="activity"
              [showLabel]="false"
              #dataEntityInput
            ></wm-data-entity-input>
            <wm-data-entity-view
              *ngIf="isReadOnly && cell.entity && !shouldRenderAsDynamicColumns(cell)"
              orientation="horizontal"
              [entity]="cell.entity"
              [form]="form"
              [applicationId]="applicationId"
              [activity]="activity"
              [showLabel]="false"
            ></wm-data-entity-view>

            <ng-container *ngIf="cell.layoutModel">
              <!-- Table Layout -->
              <wm-data-entity-table-layout-input
                *ngIf="cell.layoutModel.type === 'table-data-entity-layout'"
                [layoutModel]="cell.layoutModel"
                [form]="form"
                [isReadOnly]="isReadOnly"
                [applicationId]="applicationId"
                [activity]="activity"
              ></wm-data-entity-table-layout-input>

              <!-- Group Layout -->
              <wm-data-entity-group-layout-input
                *ngIf="cell.layoutModel.type === 'group-data-entity-layout'"
                [layoutModel]="cell.layoutModel"
                [form]="form"
                [isReadOnly]="isReadOnly"
                [applicationId]="applicationId"
                [activity]="activity"
              ></wm-data-entity-group-layout-input>

              <!-- Row Layout -->
              <wm-data-entity-row-layout-input
                *ngIf="cell.layoutModel.type === 'row-data-entity-layout'"
                [layoutModel]="cell.layoutModel"
                [form]="form"
                [isReadOnly]="isReadOnly"
                [applicationId]="applicationId"
                [activity]="activity"
              ></wm-data-entity-row-layout-input>

              <!-- Default Entity Layout -->
              <ng-container *ngIf="cell.layoutModel.type === 'default-data-entity-layout'">
                <wm-data-entity-input
                  *ngIf="!isReadOnly && cell.layoutModel.entity"
                  orientation="horizontal"
                  [entity]="cell.layoutModel.entity"
                  [form]="form"
                  [applicationId]="applicationId"
                  [activity]="activity"
                  [showLabel]="false"
                ></wm-data-entity-input>
                <wm-data-entity-view
                  *ngIf="isReadOnly && cell.layoutModel.entity"
                  orientation="horizontal"
                  [entity]="cell.layoutModel.entity"
                  [form]="form"
                  [applicationId]="applicationId"
                  [activity]="activity"
                  [showLabel]="false"
                ></wm-data-entity-view>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </ng-container>
    </tr>
    <tr *ngIf="!isReadOnly && hasInvalidDynamicColumns(row)" class="validation-row permit-form-validation-row">
      <td [attr.colspan]="getTotalColumnCount(row)" class="bg-danger text-white small text-center py-1">
        <wm-common-icon
          class="permit-form-validation-icon"
          [data]="{ iconName: 'error' }"></wm-common-icon>
        <wm-common-text
          [data]="{ text: 'Required field. Please make a selection.' }"></wm-common-text>
      </td>
    </tr>
      </ng-container>
    </ng-container>
  </table>
  </div>
}
